// TODO enable eslint
/* eslint-disable import/no-self-import */
import * as thisModule from "./constraint"

export const getId = constraint => constraint.id
export const getType = constraint => constraint.constraintTypeId
export const getValue = (constraint, key) => constraint.argumentValues[key]
export const getViolationLevel = constraint => constraint.violationLevel

export default thisModule
